import AllNotificationBell from 'shared/common/AllNotification/ui/Notification'
import AppBreadcrumb from 'shared/common/AppBreadcrumb/ui'

export function Header() {
  return (
    <div className="z-[101] h-[56px] flex justify-between items-center py-[16px] px-[24px] bg-white border-b border-light_gray_3">
      <AppBreadcrumb />
      <AllNotificationBell />
    </div>
  )
}
